<tcat-header></tcat-header>
<div class="app-container">
    <section *ngIf="isLoggedIn" class="side-menu-pane">
        <tcat-side-menu></tcat-side-menu>
    </section>
    <section class="content-pane">
        <ng-content></ng-content>
    </section>
</div>
<tcat-mobile-view-port-pane></tcat-mobile-view-port-pane>